import { Component, OnInit } from '@angular/core';
export class ProfileSectionComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-profile-section]',
  template: `
    <span class="text">
        <ng-content></ng-content>
    </span>
  `,
  styles: [`
        :host{
            display: table;
            width: 100%;
            vertical-align: middle;
            margin: 20px 20px 10px 20px;
        }
        .text{
            color:#2a61ac;
            display: table-cell;
            margin: 0;
            vertical-align: middle;
            font-weight: 600;
            font-size: 0.85rem;
            text-transform: uppercase;

        }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProfileSectionComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProfileSectionComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProfileSectionComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
